import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type DeleteProductGroupRequest = {
  id: number;
  status: string | null | undefined;
};

export type DeleteProductGroupResponse = BaseResponse<null>;

async function deleteProductGroup(
  data: DeleteProductGroupRequest
): Promise<DeleteProductGroupResponse> {
  try {
    return (await axiosInstance.delete(`/Product/DeleteProductGroup?id=${data.id}&status=${data.status}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteProductGroup() {
  return useMutation<DeleteProductGroupResponse, Error, DeleteProductGroupRequest>(
    (variables) => deleteProductGroup(variables)
  );
}
